export default __webpack_public_path__ + "static/media/GiraffePage1.c4ceddef.txt";